module.exports = __webpack_public_path__ + "static/favicon-97233ada7850d9efdb4a50306d5d22c1.ico";